import React, { useEffect, useState } from 'react';
import './Cards.css';
import CardItem from './CardItem';
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../lib/init-firebase'

function Cards() {

  const [projects, setProjects] = useState([])

  useEffect(() => {
    getProjects()
  }, [])

  useEffect(() => { 
    console.log(projects)
  }, [projects])

  function getProjects() {

    const projectsQuery = query(collection(db, 'projects'),  orderBy("index", "asc"))
    
    getDocs(projectsQuery).then(response => {
      const projects = response.docs.map(doc => ({
        data: doc.data(), 
        id: doc.id,
      }))

      setProjects(projects)
    }).catch(error => console.log(error.message))
  }

  return (
    <div className='cards'>
      <h1>Few projects I have worked on</h1>
          <div className='parent-flex'>
            {projects.filter((menu) => !menu.isHobby).map( project => (
              <div className='flex-item' key={project.id}>
                <CardItem
                  src={project.data.src}
                  text = {project.data.text}
                  label = {project.data.label}
                  path = {project.data.path}
                />
              </div>
            )
            )}
            </div>
        <h1>Hobby projects</h1>
          <div className='parent-flex'>
            {projects.filter((menu) => menu.isHobby == true).map( project => (
              <div className='flex-item' key={project.id}>
                <CardItem
                  src={project.data.src}
                  text = {project.data.text}
                  label = {project.data.label}
                  path = {project.data.path}
                />
              </div>
            )
            )}
            </div>
    </div>
  );
}

export default Cards;
